export const developers = [
  {
    name: 'Vitalij',
    surname: 'Kymko',
    gitLink: 'https://github.com/vitalij99',
    foto: 'https://avatars.githubusercontent.com/u/111449205?v=4',
  },
  {
    name: 'Dmytro',
    surname: 'Kornilov',
    gitLink: 'https://github.com/Dimar95',
    foto: 'https://avatars.githubusercontent.com/u/110562214?v=4',
  },
  {
    name: 'Borys',
    surname: 'Romanov',
    gitLink: 'https://github.com/Umberban',
    foto: 'https://avatars.githubusercontent.com/u/110768888?v=4',
  },
  {
    name: 'Anastasiia',
    surname: 'Herusova',
    gitLink: 'https://github.com/Anastasiia2302',
    foto: 'https://avatars.githubusercontent.com/u/110552981?v=4',
  },
  {
    name: 'Vladimir',
    surname: 'Diadenko',
    gitLink: 'https://github.com/VladDyadenko',
    foto: 'https://avatars.githubusercontent.com/u/110708917?v=4',
  },
  {
    name: 'Yanna',
    surname: 'Trofimova',
    gitLink: 'https://github.com/Yanna-Trofimova',
    foto: 'https://avatars.githubusercontent.com/u/111576903?v=4',
  },
  {
    name: 'Anastasiia',
    surname: 'Vakarchuk',
    gitLink: 'https://github.com/Vastasika',
    foto: 'https://avatars.githubusercontent.com/u/111005415?v=4',
  },
  {
    name: 'Nataliia',
    surname: 'Malakova',
    gitLink: 'https://github.com/natalynoele',
    foto: 'https://avatars.githubusercontent.com/u/46425788?v=4',
  },
  {
    name: 'Yaroslav',
    surname: 'Velichko',
    gitLink: 'https://github.com/BaristaYaroslv',
    foto: 'https://avatars.githubusercontent.com/u/110727630?v=4',
  },
  {
    name: 'Andrii',
    surname: 'Kryzhanivskyi',
    gitLink: 'https://github.com/Kryzhanivskyi89',
    foto: 'https://avatars.githubusercontent.com/u/111448776?v=4',
  },

  {
    name: 'Anastasiia',
    surname: 'Bakumenko',
    gitLink: 'https://github.com/AnastasiiaBakumenko',
    foto: 'https://avatars.githubusercontent.com/u/111183401?v=4',
  },
  {
    name: 'Igor',
    surname: 'Berezhnoy',
    gitLink: 'https://github.com/webdevbiv',
    foto: 'https://avatars.githubusercontent.com/u/80968651?v=4',
  },
  {
    name: 'Nikita',
    surname: 'Zhuk',
    gitLink: 'https://github.com/NVZ1994',
    foto: 'https://avatars.githubusercontent.com/u/110624272?v=4',
  },
];
